/* Copyright (c) 2017 Backpack Health LLC */

/* eslint-disable new-cap */
/* global window, INTERCOM_APP_ID, IS_ANDROID_BUILD */

import { appManifest } from './appManifest';

const APP_ID = INTERCOM_APP_ID;
const APP_CONTEXT = 'backpack';

const CustomerService = {

  initAnonymous() {
    if (!APP_ID) { return; }
    window.Intercom('boot', {
      app_id: APP_ID,
      context: APP_CONTEXT,
      hide_default_launcher: true,
    });
  },

  initUser(email, userName, cuid, verificationHash, language) {
    if (!APP_ID) { return; }

    window.Intercom('boot', {
      app_id: APP_ID,
      context: APP_CONTEXT,
      user_id: cuid,
      user_hash: verificationHash,
      email,
      name: userName,
      cuid,
      hide_default_launcher: true,
      language_override: language,
      Client: IS_ANDROID_BUILD ? 'Android' : 'Web',
      'Client Version': appManifest.app_version,
    });
  },

  show() {
    // shows messenger panel
    if (!APP_ID) { return; }

    window.Intercom('show');
  },

  hide() {
    // hides messenger panel
    if (!APP_ID) { return; }

    window.Intercom('hide');
  },

  clearCookies() {
    const cookies = document.cookie.split(';');
    document.cookie = cookies.map((c) => {
      if (c.indexOf('intercom-') > -1) {
        const parts = c.split('=');
        const name = parts[0]
        return `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`
      } else {
        return c;
      }
    }).join(';');
  },

  shutdown() {
    if (!APP_ID) {
      CustomerService.clearCookies();
      return;
    }

    try {
      if (window.Intercom) {
        window.Intercom('shutdown');
      }
    } catch {
      CustomerService.clearCookies();
    }
  },

  /*
    Intercom('showMessages');
    Intercom('showNewMessage');
    Intercom('showNewMessage', 'pre-populated content');
    Intercom('onHide', function() { // Do stuff });
    Intercom('onShow', function() { // Do stuff });
    Intercom('onUnreadCountChange', function(unreadCount) {
      // Do stuff...
    });
    Intercom('trackEvent', 'invited-friend');
    Intercom('trackEvent', 'invited-friend', metadata);
    Intercom('getVisitorId')
  */

};

export default CustomerService;
